/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class ThreatVulnerabilityStatusQueryOperator extends models.QueryOperator {
    constructor() {
        super();
        this.setDiscriminator("ThreatVulnerabilityStatusQueryOperator");
    }

    getFixupPrototypeFunction() { return ThreatVulnerabilityStatusQueryOperator.fixupPrototype; }

    static newInstance(model: Partial<ThreatVulnerabilityStatusQueryOperator>): ThreatVulnerabilityStatusQueryOperator {
        let obj = Object.assign(new ThreatVulnerabilityStatusQueryOperator(), model);
        ThreatVulnerabilityStatusQueryOperator.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<ThreatVulnerabilityStatusQueryOperator>): ThreatVulnerabilityStatusQueryOperator {
        if (!model) return null;
        return ThreatVulnerabilityStatusQueryOperator.newInstance(<ThreatVulnerabilityStatusQueryOperator> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: ThreatVulnerabilityStatusQueryOperator) {
        if (!obj) return;

        models.ThreatVulnerabilityStatusQueryOperator.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: ThreatVulnerabilityStatusQueryOperator): boolean {
        if (models.QueryOperator.setPrototype(obj))
        {
            return true; // A polymorphic type, skip overwriting the prototype.
        }
        Object.setPrototypeOf(obj, ThreatVulnerabilityStatusQueryOperator.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        super.fixupFields();
    }

    /**
     * Statuses of the vulnerability to include
     */
    statuses: Array<models.ThreatVulnerabilityStatus>;

}
